var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.5C14.2091 11.5 16 9.70914 16 7.5C16 5.29086 14.2091 3.5 12 3.5C9.79086 3.5 8 5.29086 8 7.5C8 9.70914 9.79086 11.5 12 11.5ZM12 21.5C15.866 21.5 19 19.7091 19 17.5C19 15.2909 15.866 13.5 12 13.5C8.13401 13.5 5 15.2909 5 17.5C5 19.7091 8.13401 21.5 12 21.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.613 9.90625C21.0713 9.36458 20.1931 9.36458 19.6514 9.90625L18.7818 10.7758C18.8156 10.8441 18.8522 10.9159 18.8914 10.9904C19.1553 11.4917 19.5257 12.0865 19.9696 12.5304C20.4135 12.9743 21.0084 13.3447 21.5096 13.6086C21.5841 13.6478 21.6559 13.6844 21.7242 13.7182L22.5937 12.8486C23.1354 12.3069 23.1354 11.4287 22.5937 10.887L21.613 9.90625ZM21.0557 14.3866C20.5266 14.1056 19.8585 13.6921 19.3332 13.1668C18.8079 12.6415 18.3944 11.9734 18.1134 11.4443L14.6937 14.864C14.4815 15.0762 14.3438 15.3515 14.3014 15.6486L14.0072 17.7082C13.9418 18.1659 14.3341 18.5582 14.7918 18.4928L16.8514 18.1986C17.1485 18.1562 17.4238 18.0185 17.636 17.8063L21.0557 14.3866Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSettingsIcon);
export default __webpack_public_path__ + "static/media/edit-settings-icon.081d80a3.svg";
export { ForwardRef as ReactComponent };